import { LoopElement } from './LoopElement'

function Cloud (selector, duration) {
  this.selector = selector
  this.duration = duration
  this.tween = new LoopElement(this.selector, this.duration)
}

class Clouds {
  constructor (clouds) {
    this.clouds = clouds
    this.loopElements = []
  }

  setUpTweens () {
    for (const [selector, duration] of this.clouds) {
      this.loopElements.push(new Cloud(selector, duration))
    }
  }

  animate (page) {
    this.setUpTweens()
    for (const cloud of this.loopElements) {
      cloud.tween.animate(page)
    }
  }

  disable () {
    for (const cloud of this.loopElements) {
      cloud.tween.delete()
    }
    this.loopElements = []
  }
}

export { Clouds }



// WEBPACK FOOTER //
// ./src/classes/Clouds.js